import { lighten } from '@mui/material/styles';
import { makeStyles } from '../../../styles';
export const useSwitchStyles = makeStyles((theme) => ({
    colorPrimary: {
        '& + .MuiSwitch-track': {
            height: '12px',
            opacity: 0.2,
        },
        '& .MuiSwitch-thumb': {
            width: '18px',
            height: '18px',
            boxShadow: theme.shadows[1],
        },
        '&.Mui-checked': {
            '& + .MuiSwitch-track': {
                opacity: 0.2,
            },
        },
        '&.Mui-disabled': {
            '&.Mui-checked': {
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.colors.primary.main,
                    opacity: 0.1,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: lighten(theme.colors.primary.main, 0.6),
                    '& > i': {
                        color: theme.colors.primary.contrastWhite,
                    },
                },
            },
            '&:not(.Mui-checked)': {
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.colors.primary.dark,
                    opacity: 0.3,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: theme.colors.gray[0],
                    '& > i': {
                        color: lighten(theme.colors.primary.dark, 0.6),
                    },
                },
            },
        },
        '&:not(.Mui-disabled)': {
            '&.Mui-checked': {
                color: theme.colors.primary.main,
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.colors.primary.main,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: theme.colors.primary.main,
                    '& > i': {
                        color: theme.colors.primary.contrastWhite,
                    },
                },
            },
            '&:not(.Mui-checked)': {
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.colors.primary.dark,
                    opacity: 1,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: theme.colors.primary.contrastWhite,
                    '& > i': {
                        color: theme.colors.primary.dark,
                    },
                },
            },
        },
    },
    colorSecondary: {
        '& + .MuiSwitch-track': {
            height: '12px',
            opacity: 0.2,
        },
        '& .MuiSwitch-thumb': {
            width: '18px',
            height: '18px',
            boxShadow: theme.shadows[1],
        },
        '&.Mui-checked': {
            '& + .MuiSwitch-track': {
                opacity: 0.2,
            },
        },
        '&.Mui-disabled': {
            '&.Mui-checked': {
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.colors.success.main,
                    opacity: 0.1,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: lighten(theme.colors.success.main, 0.6),
                    '& > i': {
                        color: theme.colors.primary.contrastWhite,
                    },
                },
            },
            '&:not(.Mui-checked)': {
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.colors.primary.dark,
                    opacity: 0.3,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: theme.colors.gray[0],
                    '& > i': {
                        color: lighten(theme.colors.primary.dark, 0.6),
                    },
                },
            },
        },
        '&:not(.Mui-disabled)': {
            '&.Mui-checked': {
                color: theme.colors.success.main,
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.colors.success.main,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: theme.colors.success.main,
                    '& > i': {
                        color: theme.colors.primary.contrastWhite,
                    },
                },
            },
            '&:not(.Mui-checked)': {
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.colors.primary.dark,
                    opacity: 1,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: theme.colors.primary.contrastWhite,
                    '& > i': {
                        color: theme.colors.primary.dark,
                    },
                },
            },
        },
    },
    icon: {
        fontSize: '10px !important',
        verticalAlign: 'middle',
        width: '10px',
        height: '10px',
        padding: 0,
    },
    iconWrapper: {
        width: '18px',
        height: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
    },
}));
//# sourceMappingURL=Switch.styles.js.map